export default __webpack_public_path__ + "static/media/nmp2.dd6cc313.png";